import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#73AF00"
  }} d="M38.345,88.276C17.167,88.276,0,105.443,0,126.621v217.655l388.414-256H38.345z" /><path style={{
    fill: "#4173CD"
  }} d="M473.655,423.724c21.177,0,38.345-17.167,38.345-38.345V167.724l-388.414,256H473.655z" /><path style={{
    fill: "#FFE15A"
  }} d="M473.655,88.276h-90.516L0,339.298v46.081c0,21.177,17.167,38.345,38.345,38.345h90.516L512,172.702  v-46.081C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
    fill: "#464655"
  }} d="M473.655,88.276h-42.2L0,370.953v14.426c0,21.177,17.167,38.345,38.345,38.345h42.2L512,141.047  v-14.426C512,105.443,494.833,88.276,473.655,88.276z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };